export const getFieldName = (name: string, prefix?: string): string => {
  return prefix ? `${prefix}.${name}` : name;
};
